import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UButtonComponent } from './u-button.component';
import { UIconModule } from '../u-icon/u-icon.module';

@NgModule({
  declarations: [UButtonComponent],
  imports: [CommonModule, UIconModule],
  exports: [UButtonComponent],
})
export class UButtonModule {}
